import _ from "lodash";
import { RealtimeReport } from "../../RealtimeReport";

import "../../../assets/css/RealtimeReport.css"


class DepositByTypeRealtimeReport extends RealtimeReport {

    makeLabel(appLabel, reportLabel) {
        const regionKey = this.getRegionKeyFromSubgroup(this.getSubgroups()[0]);
        const regionLabel = regionKey === 'sg' ? 'Deposit Type' : 'Consumer & Corp';
        return super.makeLabel(appLabel, regionLabel);
    }
}

export { DepositByTypeRealtimeReport }
